module.exports = __webpack_public_path__ + "media/images/home/concept_2-3fb0cd812aed49ce7e6ec3d6898f9c8e.png";